import {useQueryClient} from '@tanstack/react-query'

import {assetsHistoryQueryOptions, MomentRange} from './assetsHistoryQueryOptions'

export const usePrefetchAssetsHistory = (plantId: string, timeFrame: MomentRange) => {
  const queryClient = useQueryClient()
  void queryClient.prefetchQuery(assetsHistoryQueryOptions(plantId, timeFrame))
}
